// src/pages/Home.tsx

import React, {ReactElement, FC, useRef, useEffect} from "react";
import Viewer from '../components/Viewer';
import {autocompleteClasses, Box, Typography} from "@mui/material";
import { useGlobalState } from '../state';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CancelIcon from '@mui/icons-material/Cancel';

const Home: FC<any> = (): ReactElement => {

    const childRef: any = useRef();

    const [data, update] = useGlobalState('data');

    useEffect(() => {
        if (childRef.current) {
            if ((!data.load_started) && data.loading) {
                let load_started = true;
                update((p) => ({ ...p, load_started }));
                childRef.current.load_meshes(true, true, () => {
                    let loading = false;
                    let initdisplay = true; 
                    console.log('loading completed'); 
                    update((p) => ({ ...p, loading }));
                    update((p) => ({ ...p, initdisplay }));
                });
            } else if (data.initdisplay) {
                let initdisplay = false;
                update((p) => ({ ...p, initdisplay }));
            }
            if (data.redisplay) {
                let redisplay = false;
                update((p) => ({ ...p, redisplay }));
                childRef.current.handle_redisplay();
            }
            if (data.searchVisible && !data.searchDone) {
                let searchDone = true;
                update((p) => ({ ...p, searchDone }));
                childRef.current.search_transition(data.x,data.y,data.z,data.r);
            } else if (!data.searchDone) {
                let searchDone = true;
                let x = 0;
                let y = 0;
                let z = 0;
                update((p) => ({ ...p, searchDone }));
                update((p: any) => ({ ...p, x }));
                update((p: any) => ({ ...p, y }));
                update((p: any) => ({ ...p, z }));
                childRef.current.search_cancel();
            }
        }
    });

    const handleAccordionChange = () => (event: React.SyntheticEvent, expanded: boolean) => 
    {
        update((p) => ({ ...p, expanded }));
    };

    const handleSearchClose = () => {
        let searchVisible = false;
        update((p) => ({ ...p, searchVisible }));
        if (childRef.current) {
            let x = 0;
            let y = 0;
            let z = 0;
            update((p: any) => ({ ...p, x }));
            update((p: any) => ({ ...p, y }));
            update((p: any) => ({ ...p, z }));
            childRef.current.search_cancel();
        }
    };

    // if (!data.mesh_form_unrendered) {
    //     let mesh_form_unrendered = true;
    //     let painted_temp = data.painted;
    //     update((p) => ({ ...p, painted_temp }));
    //     update((p) => ({ ...p, mesh_form_unrendered }));
    // }

    let low = data.mesh_options[0] === 't';
    let dust = data.mesh_options[1] === 't';

    return (
        <Box sx={{
            height: '100%',
            flexGrow: 1
        }}><Viewer ref={childRef} dust={dust} low={low} initdisplay={data.initdisplay} loading={data.loading} x={data.x} y={data.y} z={data.z} />
                {/* <Grid container>
                    <Grid item xs={1} />
                    <Grid item xs={11}>
                        <Typography color="white" variant="h6">Home {JSON.stringify(data)}</Typography>
                    </Grid>
                </Grid> */}
                {/* <Popover 
                    open={data.searchVisible}
                    anchorReference="anchorPosition"
                    anchorPosition={{ top: 80, left: window.innerWidth-5}}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                > */}
                    <Accordion style={{width: '350px', margin: 'auto', backgroundColor:"#303030", display: data.searchVisible?'block':'none', position: 'absolute', top: 80, right: 15}} expanded={data.expanded} onChange={handleAccordionChange()}>
                        <AccordionSummary
                            style={{height:'50px'}}
                            expandIcon={<ExpandMoreIcon color="secondary" />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                        >
                            <Typography color="secondary" sx={{ width: '300px' }}>
                                <IconButton
                                    size="large"
                                    edge="start"
                                    aria-label="hide search result"
                                    onClick={handleSearchClose}
                                >
                                    <CancelIcon color="secondary"/>
                                </IconButton>
                                {data.label}
                            </Typography>                           
                        </AccordionSummary>
                        <AccordionDetails style={{backgroundColor:"#404040"}}>
                            <Typography color="secondary">
                                {data.description.map((item: string) => <div style={{marginBottom: '10px'}}>{item}</div>)}
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                {/* </Popover> */}
            </Box>
    );
};

export default Home;